(function (root) {
  'use strict';

  /*
   * UpCart drawer: hide private line item properties ("_mix_match: pottery",
   * "_mix_match_addon: pottery", any key starting with "_"). Shopify and the
   * theme's own cart (snippets/cart-item.liquid) already skip them; UpCart
   * prints every property. The properties must stay on the line: the
   * discount Function and the bundle UI read them.
   *
   * UpCart renders into #upCart: in the light DOM on the live theme
   * (checked 2026-10-10), in a shadow root on some UpCart versions; both are
   * handled. The hidden row is the outermost element whose text is just
   * "_key: value" (one property, nothing else), found from its text, so it
   * keeps working if UpCart changes its class names. Re-applied on every
   * UpCart re-render.
   */

  var ATTR = 'data-sculpd-private-prop';
  // "_key:" / "_key: value" / "_key" (UpCart splits name and value in spans)
  var PRIVATE = /^_[\w-]*\s*:?/;
  var ONE_PROP = /^_[\w-]*\s*:?[^:]*$/;

  function upcartRoot() {
    var host = document.querySelector('#upCart');
    if (!host) return null;
    return host.shadowRoot || host;
  }

  function clean(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function hide(scope) {
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var found = [];
    var node;
    while ((node = walker.nextNode())) {
      if (PRIVATE.test(clean(node.nodeValue)) && node.parentElement) found.push(node.parentElement);
    }
    found.forEach(function (el) {
      if (el.closest('[' + ATTR + ']')) return;
      var row = el;
      // Climb while the parent still holds only this one "_key: value" pair.
      while (row.parentElement && row.parentElement !== scope) {
        var text = clean(row.parentElement.textContent);
        if (!PRIVATE.test(text) || !ONE_PROP.test(text)) break;
        row = row.parentElement;
      }
      if (!ONE_PROP.test(clean(row.textContent))) return;
      row.setAttribute(ATTR, '');
      row.style.setProperty('display', 'none', 'important');
    });
  }

  var watched = null;
  var queued = false;
  function run() {
    queued = false;
    var scope = upcartRoot();
    if (scope) hide(scope);
  }
  function soon() {
    if (queued) return;
    queued = true;
    // setTimeout, not requestAnimationFrame: rAF is paused in background tabs.
    root.setTimeout(run, 0);
  }
  function watch() {
    var scope = upcartRoot();
    if (!scope || scope === watched) return;
    watched = scope;
    new MutationObserver(soon).observe(scope, { childList: true, subtree: true, characterData: true });
    soon();
  }

  new MutationObserver(watch).observe(document.documentElement, { childList: true, subtree: true });
  watch();
})(window);
